export const MAIL_STORAGE_UPDATED_EVENT = "mailStorageUpdated";

export type MailStorageUpdatedDetail = {
  accountId: number;
  folder?: string;
};

export function notifyMailStorageUpdated(accountId: number, folder?: string): void {
  window.dispatchEvent(
    new CustomEvent<MailStorageUpdatedDetail>(MAIL_STORAGE_UPDATED_EVENT, {
      detail: { accountId, folder },
    })
  );
}

export function subscribeMailStorageUpdated(
  listener: (detail: MailStorageUpdatedDetail) => void
): () => void {
  const handler = (event: Event) => {
    const detail = (event as CustomEvent<MailStorageUpdatedDetail>).detail;
    if (detail) listener(detail);
  };
  window.addEventListener(MAIL_STORAGE_UPDATED_EVENT, handler);
  return () => window.removeEventListener(MAIL_STORAGE_UPDATED_EVENT, handler);
}
